module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid page-head-wrap"
  }, [_c('div', {
    staticClass: "container page-head"
  }, [_c('h3', {
    staticClass: "h4 text-center"
  }, [_c('b', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[15][1]"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-md-2 col-md-8 px-md-5"
  }, [(_vm.apiErrorI18nKey) ? _c('div', {
    staticClass: "alert alert-danger mt-3",
    attrs: {
      "role": "alert"
    }
  }, [_c('b', [_c('trans-text', {
    attrs: {
      "i18nKey": _vm.apiErrorI18nKey
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-wrap"
  }, [_c('div', {
    staticClass: "form-list py-3"
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.password.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[15][4]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.input.password),
      expression: "input.password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "password",
      "value": "",
      "placeholder": "********"
    },
    domProps: {
      "value": (_vm.input.password)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.password.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.password,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error[15][1]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "my-2"
  }, [_c('button', {
    staticClass: "btn w-100 btn-lg btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.tryForm
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[15][5]"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "my-2"
  }, [_c('router-link', {
    staticClass: "btn w-100 btn-lg btn-default",
    attrs: {
      "tag": "button",
      "to": {
        name: 'password-remind-from',
        params: {}
      }
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[15][6]"
    }
  })], 1)], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-85fbb928!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/PasswordRemindVerify.vue
// module id = 719
// module chunks = 0